'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Toaster } from 'sonner';

export function ToasterProvider() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const toaster = (
    <Toaster
      position="top-right"
      expand={false}
      richColors
      closeButton
      theme="dark"
      visibleToasts={5}
      offset={16}
      gap={5}
      toastOptions={{
        style: {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },
        duration: 4000,
      }}
    />
  );

  if (!mounted) return null;
  return createPortal(toaster, document.body);
}
